export const FEATURE = Object.freeze({
    BACKUP_ENTITY: 'BackupEntity',
    BACKUP_LIFESPAN: 'BackupLifespan',
    BACKUP_RECORD: 'BackupRecord',
    BACKUP_RUN: 'BackupRun',
    BACKUP_SCHEDULE: 'BackupSchedule',

    MIGRATION_RECORD: 'MigrationRecord',
    MIGRATION_RUN: 'MigrationRun',
    MIGRATION_SCOPE: 'MigrationScope',
    MIGRATION_FILTERS: 'MigrationFilters',
    MIGRATION_DELTA: 'MigrationDelta',
    MIGRATION_UPDATE_MATCHED: 'MigrationUpdateMatched',
    MIGRATION_UPDATE_PROPERTIES: 'MigrationUpdateProperties',

    CALENDAH_AVAILABLE: 'CalendahAvailable',
    CALENDAH_ACTIVE_CALENDAR: 'CalendahActiveCalendar',
    CALENDAH_SHARE_SCOPE: 'CalendahShareScope',
    CALENDAH_SCOPE: 'CalendahScope',
    CALENDAH_VIEW: 'CalendahView',
    CALENDAH_RANGE: 'CalendahRange',
    CALENDAH_PROVIDER: 'CalendahProvider',

    ASSET_ESTIMATE_CREATE: 'AssetEstimateCreate',
    ASSET_ESTIMATE_RECORD_VIEW: 'AssetEstimateRecordView',
    ASSET_ESTIMATE_RECORD_STATE: 'AssetEstimateRecordState',
    ASSET_ESTIMATE_REPORT: 'AssetEstimateReport',
    ASSET_ESTIMATE_RATES_MANAGEMENT: 'AssetEstimateRatesManagement',
});

export const FIELD = Object.freeze({
    NAME: 'name',
    IS_PRIMARY: 'isPrimary',
    INCREMENTABLE: 'incrementable',
    PRICE: 'price',
    DATA: 'data',
    ADD_ONS: 'addOns',
});

export const DATA = Object.freeze({
    INCREMENT: 'increment',
    VALUE: 'value',
    VALUE_USED: 'valueUsed',
    VALUE_UNIT: 'valueUnit',
    SCOPE: 'scope',
    EXCLUDE: 'exclude',
    COUNT: 'count',
    FORMAT: 'format',
});

export const RECORD_SCOPE = Object.freeze({
    INSTANCE: 'instance',
    INSTANCE_ENTITY: 'instance entity',
});

export const RUN_SCOPE = Object.freeze({
    DEMO: 'demo',
    FULL: 'full',
});

export const VALUE_UNIT = Object.freeze({
    DAY: 'day',
    WEEK: 'week',
    MONTH: 'month',
});

export const SCHEDULE = Object.freeze({
    DAILY: 'daily',
    WEEKLY: 'weekly',
    MONTHLY: 'monthly',
});

export const FORMAT = Object.freeze({
    FIXED: 'fixed',
    DYNAMIC: 'dynamic',
});
